var map = {
	"./aarti.svg": 137,
	"./amararaja.svg": 138,
	"./amiOrganicsLogo.svg": 117,
	"./apollohospitals.svg": 344,
	"./ashokLeyland.svg": 125,
	"./aveo.svg": 345,
	"./ayana.svg": 67,
	"./birlaGroupLogo.svg": 120,
	"./bitmore.svg": 346,
	"./bluePlanet.svg": 129,
	"./burgerking.svg": 347,
	"./calibre.svg": 348,
	"./ceat.svg": 102,
	"./cgpower.svg": 68,
	"./chemopharm.svg": 69,
	"./cipla.svg": 349,
	"./cochinshipyard.svg": 350,
	"./cohizon.svg": 351,
	"./cookieman.svg": 352,
	"./cpc.svg": 70,
	"./cumiLogo.svg": 121,
	"./data_esg.svg": 66,
	"./deepak_nitrite_logo.svg": 108,
	"./dominos.svg": 353,
	"./dsg.svg": 354,
	"./emrill.svg": 71,
	"./epsilonLogo.svg": 118,
	"./escortsKubota.svg": 130,
	"./eveready.svg": 139,
	"./everenviro.svg": 73,
	"./everest_industrial_logo.svg": 109,
	"./everise.svg": 74,
	"./everlife-1.svg": 76,
	"./everlife.svg": 75,
	"./eversource.svg": 77,
	"./everstone.svg": 355,
	"./fnb_asia.svg": 356,
	"./freshways.svg": 357,
	"./ghcl.svg": 101,
	"./gmr.svg": 140,
	"./gokaldasExports.svg": 126,
	"./grInfra.svg": 127,
	"./greencell.svg": 78,
	"./harrys.svg": 358,
	"./harrys_logo.svg": 110,
	"./hcl.svg": 359,
	"./hinduja.svg": 145,
	"./igarashiMotors.svg": 128,
	"./iifl_finance.svg": 79,
	"./indoramaCorporation.svg": 131,
	"./indospace.svg": 80,
	"./indostar.svg": 81,
	"./infostretch.svg": 82,
	"./infosys.svg": 360,
	"./ips.svg": 146,
	"./jKCements.svg": 123,
	"./jsla.svg": 141,
	"./kathari.svg": 83,
	"./kuantumPapers.svg": 124,
	"./lTFinance.svg": 132,
	"./lakshmimachineworks.svg": 84,
	"./licious.svg": 361,
	"./lithium.svg": 85,
	"./lloyd_metals.svg": 111,
	"./lodha.svg": 362,
	"./lupin.svg": 86,
	"./mastek.svg": 112,
	"./multiples.svg": 104,
	"./narayanaHealthLogo.svg": 122,
	"./omega_healthcare.svg": 363,
	"./pgp_glass.svg": 87,
	"./polycycle.png": 364,
	"./polyplastics.svg": 133,
	"./pricol.svg": 365,
	"./prism-johnson.svg": 134,
	"./protean_logo.svg": 366,
	"./radiaant_logo.svg": 113,
	"./radiance.svg": 88,
	"./rakbank.svg": 147,
	"./ramco.svg": 89,
	"./re_sustainability.svg": 90,
	"./refex.svg": 106,
	"./republicBank.svg": 105,
	"./rhi_magnesita.svg": 91,
	"./sahyadri.svg": 92,
	"./sbi_card.svg": 72,
	"./servion.svg": 93,
	"./shapoorji_pallonji_logo.svg": 114,
	"./shoprite.svg": 149,
	"./sjs.svg": 94,
	"./skf.svg": 367,
	"./softgel.svg": 95,
	"./sohanlal.svg": 96,
	"./sulochana.svg": 103,
	"./sunpharma.svg": 97,
	"./supremeLogo.svg": 115,
	"./sutherlandLogo.svg": 119,
	"./suzlonLogo.svg": 116,
	"./tata-consumer-products.svg": 135,
	"./tata-projects.svg": 144,
	"./tatapower.svg": 98,
	"./tech-mahindra-ctco.svg": 148,
	"./tolaram.svg": 99,
	"./translumina.svg": 100,
	"./trident.svg": 136,
	"./uflex.svg": 142,
	"./wns.svg": 143,
	"./zahid_group.svg": 368,
	"./zee.svg": 107,
	"./zomato.svg": 369
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1116;